import { MODULES, type ModuleId } from "./curriculum";

export interface Badge {
  id: string;
  name: string;
  description: string;
  emoji: string;
  /** Returns true if the badge is earned given current progress. */
  earned: (ctx: BadgeContext) => boolean;
}

export interface BadgeContext {
  completedLessons: string[];
  xp: number;
  moduleCompletion: Record<ModuleId, { done: number; total: number }>;
  allComplete: boolean;
}

/** One badge per module, plus milestone badges. */
export const BADGES: Badge[] = [
  {
    id: "first-step",
    name: "First Step",
    description: "Complete your very first lesson.",
    emoji: "👟",
    earned: (c) => c.completedLessons.length >= 1,
  },
  ...MODULES.map<Badge>((m) => ({
    id: `module-${m.id}`,
    name: `${m.title} Graduate`,
    description: `Finish every lesson in ${m.title}.`,
    emoji: m.emoji,
    earned: (c) => {
      const mc = c.moduleCompletion[m.id];
      return mc ? mc.done >= mc.total : false;
    },
  })),
  {
    id: "xp-100",
    name: "Century Club",
    description: "Earn 100 XP.",
    emoji: "💯",
    earned: (c) => c.xp >= 100,
  },
  {
    id: "graduate",
    name: "BCH Graduate",
    description: "Complete the entire BCH School curriculum.",
    emoji: "🎓",
    earned: (c) => c.allComplete,
  },
];
